import React, {useCallback, useState, useEffect, useMemo, useRef} from 'react';
import axios from "axios";
import {AgGridReact} from 'ag-grid-react';
import CatchModalContent from '../components/modals/CatchModalContent';
import EditCatchModal from '../components/modals/EditCatchModal';
import DeleteCatchModal from '../components/modals/DeleteCatchModal';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { fishSpeciesList, catchHeaderList } from '../refs/lists';
import { toast } from 'react-toastify';
import '../components/AdminRegistrationTabs.css';

function AdminCatches () {

  const [registerAnglerCatchModal, setRegisterAnglerCatchModal] = useState(false);
  const [registerBoatCatchModal, setRegisterBoatCatchModal] = useState(false);
  const [editCatchModal, setEditCatchModal] = useState(false);
  const [deleteCatchModal, setDeleteCatchModal] = useState(false);
  const [anglerList, setAnglerList] = useState();
  const [boatList, setBoatList] = useState();
  const [rowData, setRowData] = useState([]);
  const [selectedRow, setSelectedRow] = useState([]);

  const numberSort = (num1, num2) => {
    return num1 - num2;
  }

  const [columnDefs, setColumnDefs] = useState([
    {field: 'id', hide: true},
    {field: 'fish', checkboxSelection: true},
    {field: 'firstName', hide: true},
    {field: 'lastName', hide: true},
    {field: 'boatName'},
    {field: 'weight', comparator: numberSort},
    {field: 'length', comparator: numberSort},
    {field: 'girth', comparator: numberSort},
    {field: 'date'},
    {field: 'time'},
    {field: 'points', comparator: numberSort},
    {field: 'isTagged', hide: true},
  ]);

  const defaultColDef = {
    sortable: true,
    filter: true,
    floatingFilter: true,
    resizable: true,
    rowSelection: 'single',
    width: 150,
  }

  useEffect(() => {

    // Get angler list
    const fetchRegisteredAnglersFromDatabase = async () => {
      let params = {
        method: 'GET',
        url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getAllAnglers',
        headers: {'Content-Type': 'application/json'},
      }
      let response = await axios(params);
      let responseList = []
      if(response.data) {
        response.data.forEach((entry) => {
          responseList.push(entry)
        })
      }
      setAnglerList(responseList);
    }
    fetchRegisteredAnglersFromDatabase();

    // Get boat list
    const fetchRegisteredBoatsFromDatabase = async () => {
      let params = {
        method: 'GET',
        url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getAllBoats',
        headers: {'Content-Type': 'application/json'},
      }
      let response = await axios(params);
      let responseList = []
      if (response.data) {
        response.data.forEach((entry) => {
          responseList.push(entry)
        })
      }
      setBoatList(responseList);
    }
    fetchRegisteredBoatsFromDatabase();

    // Get catch list
    const fetchRegisteredCatchesFromDatabase = async () => {
      let params = {
        method: 'GET',
        url: 'https://billfish-pachanga-2023-c7f6b33ed232.herokuapp.com/server/getAllCatches',
        headers: {'Content-Type': 'application/json'},
      }
      let response = await axios(params);
      let responseList = []
      if (response.data) {
        response.data.forEach((entry) => {
          entry["date"] = entry["date"].split("T")[0]
          responseList.push(entry)
        })
      }
      setRowData(responseList);
    }
    fetchRegisteredCatchesFromDatabase();

  }, []);

  const toggleEditCatchModal = () => {
    setEditCatchModal(!editCatchModal);
  }

  const toggleDeleteCatchModal = () => {
    setDeleteCatchModal(!deleteCatchModal);
  }

  const toggleRegisterAnglerCatchModal = () => {
    setRegisterAnglerCatchModal(!registerAnglerCatchModal);
  }

  const toggleRegisterBoatCatchModal = () => {
    setRegisterBoatCatchModal(!registerBoatCatchModal);
  }

  const handleRowSelection = (e) => {
    console.log(e.api.getSelectedRows());
    setSelectedRow(e.api.getSelectedRows());
  }

  const handleEditRow = () => {
    if (selectedRow.length > 0) {
      toggleEditCatchModal();
    } else {
      toast.info("Select a the row you would like to edit first.");
    }
  }

  const handleDeleteRow = () => {
    if (selectedRow.length > 0) {
      toggleDeleteCatchModal();
    } else {
      toast.info("Select a the row you would like to delete first.");
    }
  }

  return <>

    {editCatchModal && (
      <EditCatchModal anglerList={anglerList} boatList={boatList} selectedRow={selectedRow} fishSpeciesList={fishSpeciesList} toggleModal={toggleEditCatchModal} />
    )}

    {deleteCatchModal && (
      <DeleteCatchModal selectedRow={selectedRow} toggleModal={toggleDeleteCatchModal} />
    )}

    {registerAnglerCatchModal && (
      <CatchModalContent catchByAngler={true} anglerList={anglerList} boatList={boatList} fishSpeciesList={fishSpeciesList} toggleModal={toggleRegisterAnglerCatchModal} />
    )}

    {registerBoatCatchModal && (
      <CatchModalContent catchByAngler={false} anglerList={anglerList} boatList={boatList} fishSpeciesList={fishSpeciesList} toggleModal={toggleRegisterBoatCatchModal} />
    )}

    <div className="container">
      <div id="myGrid" class="ag-theme-alpine" style={{width: "100%", height: 500}}>
        <button className="btn-edit" onClick={handleEditRow}>Edit Selected</button>
        <button className="btn-delete" onClick={handleDeleteRow}>Delete Selected</button>
        <button className="btn-register" onClick={toggleRegisterBoatCatchModal}>Register New Catch by Boat</button>
        <button className="btn-register" disabled={true} onClick={toggleRegisterAnglerCatchModal}>Register New Catch by Angler</button>
        <br/>
        <br/>
        <br/>
        <AgGridReact
          rowData={rowData}
          columnDefs={columnDefs}
          animateRows={true}
          defaultColDef={defaultColDef}
          rowSelection="single"
          onSelectionChanged={handleRowSelection}
        />
      </div>
    </div>
  </>
}

export default AdminCatches;

